<div class="itsl-course-info-box__image">
    {#if imageUrl}
        <img src={imageUrl} style={imageStyle} alt={imageDescription} />
    {:else}
        <div class="itsl-course-info-box__image-placeholder" style={imageStyle}></div>
    {/if}
</div>

<script>
    import config from "../../config";

    const imageColour = config.courseColour;
    const imageDescription = config.courseImageDescription;
    const imageUrl = config.courseImageUrl;

    const imageStyle = `background-color: ${imageColour}`;
</script>
